import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  PARTICIPANTS(state, participants) {
    state.cached = participants
  },
}

export const actions = {

  init({ state, dispatch }) { },

  fetchParticipants(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/masters/participants/${query}`).then((response) => {
      const request = response.data
      context.commit('PARTICIPANTS', participants)
      return request
    })
  },

  fetchParticipantsOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/masters/participants/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchParticipantsDetail(context, id) {
    return axios.get(`${serverUrl}/api/masters/participants/${id}/`).then((response) => {
      return response.data
    })
  },
  fetchParticipantByIdentification(context, identification) {
    return axios.get(`${serverUrl}/api/masters/participants/get_by_identification/?identification=${identification}`).then((response) => {
      return response.data
    })
  },

  createUpdateParticipants(context, formData) {
    let promise = null
    if (formData.id) {
      promise = axios.put(`${serverUrl}/api/masters/participants/${formData.id}/`, formData)
    } else {
      promise = axios.post(`${serverUrl}/api/masters/participants/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },




  deleteParticipants(context, permUrl) {
    let promise = null
    promise = axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },



}